import React from 'react'
import { useLocation } from "react-router-dom";
import Header from './Common/Header';
import Footer from './Common/Footer';
import ScrollToTop from './const';

const Layout = ({ children }) => {
  const location = useLocation();
  return (
    <>
    <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default Layout